import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function GapSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-295">
      <div className="max-w-copy mx-auto" data-id="element-296">
        {/* Section label */}
        <FadeIn data-id="element-297">
          <div className="flex items-center gap-4 mb-16" data-id="element-298">
            <div className="h-px bg-border-accent flex-grow" data-id="element-299" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-300">
              ◆ The Gap ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-301" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-302">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-14 text-center leading-tight" data-id="element-303">
            Why the Gap Exists —
            <br className="hidden md:block" data-id="element-304" />
            And Why It Matters
          </h2>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-primary" data-id="element-305">
          <FadeIn delay={0.15} data-id="element-306">
            <p data-id="element-307">
              When someone with millions of followers dies under circumstances
              that shake a nation, two things happen simultaneously:
            </p>
          </FadeIn>

          {/* Elevated one-liner — the emotional anchor */}
          <FadeIn delay={0.2} data-id="element-308">
            <p className="font-display text-2xl md:text-3xl font-bold text-text-primary py-4" data-id="element-309">
              Media reports the surface. Depth disappears.
            </p>
          </FadeIn>

          {/* Visual gap — broken gold line */}
          <FadeIn delay={0.25} data-id="element-310">
            <div className="flex items-center gap-6 my-6" data-id="element-311">
              <div className="h-px bg-accent-primary/40 flex-grow" data-id="element-312" />
              <span className="font-mono text-xs text-accent-muted tracking-widest" data-id="element-313">
                THE GAP
              </span>
              <div className="h-px bg-accent-primary/40 flex-grow" data-id="element-314" />
            </div>
          </FadeIn>

          {/* The contrast — what happens vs what's missing */}
          <FadeIn delay={0.3} data-id="element-315">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-8" data-id="element-316">
              <div className="border border-border-default bg-surface rounded-sm p-6" data-id="element-317">
                <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-muted mb-4" data-id="element-318">
                  What You Got
                </p>
                <div className="space-y-3 font-body text-base text-text-secondary" data-id="element-319">
                  <p data-id="element-320">Memes and hashtags</p>
                  <p data-id="element-321">Headlines written for the click</p>
                  <p data-id="element-322">A news cycle that moved on in 72 hours</p>
                </div>
              </div>
              <div className="border border-accent-primary/40 bg-elevated rounded-sm p-6" data-id="element-323">
                <p className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary mb-4" data-id="element-324">
                  What Was Missing
                </p>
                <div className="space-y-3 font-body text-base text-text-primary" data-id="element-325">
                  <p data-id="element-326">Comprehension, not just coverage</p>
                  <p data-id="element-327">Context, history, and depth</p>
                  <p data-id="element-328">Someone who took it seriously</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.35} data-id="element-329">
            <p data-id="element-330">
              Those who wanted to truly understand — what happened, why it
              matters, what it means for the future — were left without answers.
            </p>
          </FadeIn>

          {/* Blockquote */}
          <FadeIn delay={0.4} data-id="element-331">
            <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 my-12" data-id="element-332">
              <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-333">
                "The Voice They Couldn't Silence" fills exactly that void.
              </p>
            </div>
          </FadeIn>

          {/* CTA in card */}
          <FadeIn delay={0.45} data-id="element-334">
            <div className="flex flex-col items-center mt-12 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-335">
              <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-336">
                Don't let it disappear.
              </p>
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-337">
                Own The Memorial &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-338">
                Instant access. Permanent download.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}